import {
  EContractAgreement,
  EOrderVehicle,
} from "./LanguagePack/translatedFields";
import { ContractField, formatDateTime } from "./common";
import {
  Typography,
  Stack,
  Box,
  TextField,
  InputAdornment,
  useTheme,
} from "@mui/material";
import { titleStyle } from "./styles";
import { useEffect, useState } from "react";
import { Edit } from "@mui/icons-material";

export default function ContractAgreement({
  selectedLanguage,
  contractSettings,
  reservation,
}) {
  const [agreementDetails, setAgreementDetails] = useState(
    EOrderVehicle[selectedLanguage].FILL_UP_FUEL_LABEL
  );
  const theme = useTheme();

  const fields = EContractAgreement[selectedLanguage];

  useEffect(() => {
    if (contractSettings?.showContractAgreementDetails) {
      setAgreementDetails(EOrderVehicle[selectedLanguage].FILL_UP_FUEL_LABEL);
    }
  }, [selectedLanguage, contractSettings?.showContractAgreementDetails]);

  if (!reservation) {
    return null;
  }

  //@ts-ignore
  const { authTime, signerName, ssn } = reservation;

  if (
    //@ts-ignore
    reservation?.signStatus === "PENDING" ||
    //@ts-ignore
    reservation?.signStatus === "COMPLETED"
  ) {
    return "";
  }
  //@ts-ignore
  if (reservation?.authStatus === "COMPLETED") {
    const digitalSignature = authTime ? (
      <div>
        {authTime
          ? `(${formatDateTime(new Date(authTime))}) ${signerName} ${ssn}`
          : ""}
        :
      </div>
    ) : null;
    return (
      <Stack direction={"column"}>
        <ContractField
          label={fields.DIGITAL_SIGNATURE}
          value={digitalSignature}
        />
      </Stack>
    );
  }

  return (
    <Stack direction={"column"}>
      <Typography sx={titleStyle}>{fields.AGREEMENT_TITLE}</Typography>
      <Box sx={{ border: "1px solid lightgrey", padding: "2px" }}>
        {contractSettings?.showContractAgreementDetails && (
          <Typography sx={{ fontSize: "10px", fontWeight: 550 }}>
            {agreementDetails}
          </Typography>
        )}

        <Typography sx={{ fontSize: "8px" }}>
          {fields.AGREEMENT_TERMS}
        </Typography>
      </Box>
    </Stack>
  );
}
